Vue.component('ack-slider', {
	delimiters: ['${', '}$'], // (i) We set up custom delimiters to avoid conflict with liquid interpolations.
	template: '#ack-slider',
	mounted() {
		this.setSlider();

		setTimeout(() => {
			this.carousel = new bootstrap.Carousel('#' + this.carouselId);
		}, 1000);
	},
	props: {
		slides: {
			type: Array,
		},
		carouselId: {
			type: String,
		},
		showButtonsPrevNext: {
			type: Boolean,
			default: false,
		},
		isMobile: {
			type: Boolean,
		},
	},
	computed: {
		//...Vuex.mapGetters('navBar', ['switchMobileDropdowns']),
	},
	data() {
		return {
			slideList: null,
			carousel: null,
		};
	},
	methods: {
		//...Vuex.mapActions(['sayHi', 'someAction']),
		//...Vuex.mapActions('navBar', ['sayHi', 'closeAllMobileDropdowns']),

		setSlider() {
			//&& this.slides != []
			if (this.slides != null) {
				this.slideList = this.slides
					.filter((m) => {
						if (this.isMobile) {
							return m.platform == 'mobile';
						} else {
							return m.platform == 'desktop';
						}
					})
					.sort((a, b) => a.order - b.order);
			} else {
				this.slideList = [
					{
						img: 'https://cdn.shopify.com/s/files/1/0276/4174/1415/files/ALPHA_AI_CAD_Functions_Slider_Slider_1980.jpg?v=1725271739',
						imgMobile:
							'https://cdn.shopify.com/s/files/1/0276/4174/1415/files/ALPHA_AI_CAD_Functions_Slider_Slider_480.jpg?v=1725271739',
						alt: 'alpha-ai',
						title: 'ALPHA AI',
						startDate: '',
						endDate: '',
						active: true,
						href: 'https://ackuretta.com/pages/alpha-ai-slicing-software-for-dental-3d-printing',
					},
					{
						img: 'https://cdn.shopify.com/s/files/1/0276/4174/1415/files/FLOW_Slider_1980.jpg?v=1722330351',
						imgMobile:
							'https://cdn.shopify.com/s/files/1/0276/4174/1415/files/FLOW_Slider_480.jpg?v=1722330394',
						alt: 'flow-resins',
						title: 'FLOW Resins',
						startDate: '',
						endDate: '',
						active: false,
						href: 'https://ackuretta.com/pages/flow-resins-for-dental-3d-printed-applications',
					},
					{
						img: 'https://cdn.shopify.com/s/files/1/0276/4174/1415/files/NFinity_Slider_1980.jpg?v=1720522505',
						imgMobile:
							'https://cdn.shopify.com/s/files/1/0276/4174/1415/files/NFinity_Slider_480.jpg?v=1720522505',
						alt: 'curie-plus-nfinity',
						title: 'CURIE Plus & NFinity',
						startDate: '',
						endDate: '',
						active: false,
						href: 'https://ackuretta.com/products/curie-plus-nitrogen-compatible-uv-oven',
					},
					{
						img: 'https://cdn.shopify.com/s/files/1/0276/4174/1415/files/SOL_Resin_Heater_Slider_1980.jpg?v=1716451947',
						imgMobile:
							'https://cdn.shopify.com/s/files/1/0276/4174/1415/files/SOL_Resin_Heater_Slider_480.jpg?v=1716451947',
						alt: 'sol-heater',
						title: 'SOL Heater',
						startDate: '',
						endDate: '',
						active: false,
						href: 'https://ackuretta.com/products/sol#image-element-section',
					},
					{
						img: 'https://cdn.shopify.com/s/files/1/0276/4174/1415/files/3DPS_Plus_1440_Slider.jpg?v=1710213763',
						imgMobile:
							'https://cdn.shopify.com/s/files/1/0276/4174/1415/files/3DPS_Plus_390_Slider.jpg?v=1710213763',
						alt: '3dps-plus',
						title: '3DPS Plus',
						startDate: '',
						endDate: '',
						active: false,
						href: 'https://ackuretta.com/products/sol-plus',
					},
					{
						img: 'https://cdn.shopify.com/s/files/1/0276/4174/1415/files/Ortho-Model_1440_Slider.jpg?v=1710213763',
						imgMobile:
							'https://cdn.shopify.com/s/files/1/0276/4174/1415/files/Ortho-Model_390_Slider.jpg?v=1710213763',
						alt: 'ortho-model',
						title: 'CURO Ortho Model',
						startDate: '',
						endDate: '',
						active: false,
						href: 'https://ackuretta.com/pages/curo-resins',
					},
					{
						img: 'https://cdn.shopify.com/s/files/1/0276/4174/1415/files/CURO_Element_Model_Slider_Slider_1980_020478f1-e6f6-4d95-826e-893ea4f75ce3.jpg?v=1747133233',
						imgMobile:
							'https://cdn.shopify.com/s/files/1/0276/4174/1415/files/CURO_Element_Model_Slider_Slider_480_4298856f-8fed-47e0-b7a5-a3a0f966882b.jpg?v=1747133233',
						alt: 'element-model',
						title: 'CURO Element Model',
						startDate: '',
						endDate: '',
						active: false,
						href: 'https://ackuretta.com/pages/curo-resins',
					},
				];
			}
		},
	},
	beforeDestroy() {},
	watch: {
		slides: {
			handler() {
				this.setSlider();
			},
			deep: false,
		},
		isMobile: {
			handler() {
				this.setSlider();
			},
			deep: false,
		},
	},
});
